
import styles from './PersonCard.module.scss'
import React, {DetailedHTMLProps, HTMLAttributes} from "react";
import {Person} from "@/types/person";
import {InteractionStats} from "@/types/interactionStats";
import Mensenlinq from "@/Atoms/Icons/Mensenlinq";
import Pen from "@/Atoms/Icons/Pen";
import Flower from "@/Atoms/Icons/Flower";
import Candle from "@/Atoms/Icons/Candle";
import Birth from "@/Atoms/Icons/Birth";
import Deceased from "@/Atoms/Icons/Deceased";
import Panel from "@/Atoms/Panel";
import ObituaryType from "@/types/ObituaryType";

interface CardProps extends DetailedHTMLProps<HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  person: Person,
  stats?: InteractionStats,
  isOnline?: boolean,
  isObituary?: boolean,
  isLocked?: boolean,
  baseUrl?: (person: Person) => string,
  className?: string,
}

export default function PersonCard(
  {
    className,
    person,
    stats,
    baseUrl,
    isOnline,
    isObituary,
    ...props
  }: CardProps) {

  const publishDate = null;//person.publish_from ? moment(person.publish_from).format(dateTimeFormat) : null
  let obituaryUrl = baseUrl ? baseUrl(person) : `/overlijdensberichten/${person.slug}`

  const {name, birth, deceased, papers, avatar, obituary_type} = person
  const obituaryTypeClass = (obituary_type === ObituaryType.Basic)
    ? styles.basic :
    (obituary_type === ObituaryType.Extended)
      ? styles.extended
      : styles.regular;

  return <Panel className={[styles.card, className, obituaryTypeClass].join(' ')} {...props} href={obituaryUrl}>
    {person.is_locked &&  <div className={styles.locked}><i className="fa-solid fa-unlock beigedarker"></i></div>}
    <div className={styles.avatar}>
      {obituary_type === ObituaryType.Extended && avatar && avatar.url ? <img src={avatar.url} alt={''}/> : <Mensenlinq />}
    </div>
    {(typeof isOnline !== 'undefined') && <div className={styles.publishState}>{isOnline
      ? <>
        {/*<i className="fa-solid fa-eye text-green-500"></i>*/}
      </>
      : <span className={'hover'} data-title={`Zichtbaar vanaf ${publishDate}`}><i className="fa-solid fa-eye-slash primary"></i></span>
    }</div>}
    {isObituary && <div className={styles.isObituary}><div>Uitgebreid</div></div>
      }
      <div className={styles.content}>
      <div className={styles.title}>{name}</div>
      {(birth) && (
        <div className={styles.meta}><Birth />{birth}</div>
      )}
      {(deceased) && (
        <div className={styles.meta}><Deceased />{deceased}</div>
      )}
      {/*<div className={styles.meta}>{papers.map(paper => paper.title).join(', ')}</div>*/}
    </div>
    {stats && <ul className={styles.stats}>
      <li><Pen />{stats.condolences}</li>
      <li><Flower /> {stats.flowers}</li>
      <li><Candle /> {stats.candles}</li>
    </ul>}

  </Panel>
}
